import { recordListingEvent } from '../../../../Redux/Actions/recordListingEvent';
import CallLink from '../../../common/CallLink';
import PageLoader from '../../../common/PageLoader';
import React from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useParams } from 'react-router-dom';
// import { AllPackages, GetOnePackage } from '../../../Redux/actions/HomeAction';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import $, { map } from 'jquery';
import { DETAIL_LIST } from '../../../../Redux/Actions/ActionType';
import 'react-image-gallery/styles/css/image-gallery.css';
import MapModalForView from '../../../common/Modal/MapModalForView';
import { CommonBanner } from '../CommonBanner';
import { externalUrl } from "../../../../utils/externalUrl";
import { useTranslation } from 'react-i18next';

var config = {
  headers: {
    'Content-Type': 'application/json',
    Authorization: sessionStorage.getItem('loged_In_auth'),
  },
};

const defaultImages = [
  {
    original: 'assets/images/service-provider/air-conditioning/banner-b.jpg',
  },
];

const openStatus = ['OPEN', 'مفتوح'];

export default function AirConditioningDetails() {
  const { t, i18n } = useTranslation();
  const isRTL = (i18n.language || 'en').toLowerCase().startsWith('ar');
  var home = useSelector((state) => state.home);
  const DetailList = home?.getDetailList?.[0];
  const dispatch = useDispatch();
  const { airConditioningId } = useParams();
  useEffect(() => { if (airConditioningId) recordListingEvent(airConditioningId, 'airConditioning', 'VIEW'); }, [airConditioningId]);
  const [mapModalOpen, setMapModalOpen] = useState(false);

  useEffect(() => {
    const fetchDetail = async (data) => {
      var object = { airConditioningId };
      console.log('this is fatch ondata ', object);
      let query = '';
      Object.keys(object).forEach((key) => {
        console.log('this is object key', key);
        query += key + '=' + object[key] + '&';
      });
      query = query.slice(0, -1);
      console.log('this is the,', query);
      try {
        axios

          .get(
            `https://api.carsavenue.com/api/airConditioning/listing` +
              '?' +
              query,

            config
          )

          .then((res) => {
            console.log('heeee<<<<', res);
            dispatch({
              type: DETAIL_LIST,
              payload: res.data.response,
            });

            console.log('heeee<<<<', res);
          })
          .catch((err) => {
            console.log(err);
          });
      } catch (err) {}
    };
    if (airConditioningId && airConditioningId !== '')
      fetchDetail({ airConditioningId });
  }, [airConditioningId, dispatch]);

  if (!DetailList) {
    return (
      <>
        {/* <h2>dsdasdfasdf</h2> */}
        <div
          className="text-center text-warning"
          const
          style={{
            position: 'fixed',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <PageLoader /> <br />
        </div>
      </>
    );
  }

  console.log('DetailList1', DetailList);

  let bannerImages = defaultImages;

  if (DetailList?.businessMedia && DetailList.businessMedia.length > 0) {
    const mediaImages = DetailList.businessMedia
      .filter(
        (mediaItem) =>
          mediaItem?.media?.path &&
          (mediaItem.mediaType === 'MAIN_BANNER' ||
            mediaItem.mediaType === 'BANNER')
      )
      .sort(
        (a, b) =>
          (a.mediaType === 'MAIN_BANNER' ? 0 : 1) -
          (b.mediaType === 'MAIN_BANNER' ? 0 : 1)
      )
      .map((mediaItem) => ({
        original: mediaItem.media.path,
        thumbnail: mediaItem.media.path,
      }));

    if (mediaImages.length > 0) {
      bannerImages = mediaImages;
    }
  }

  const logo = DetailList?.businessMedia?.find(
    (item) => item.mediaType === 'LOGO'
  )?.media?.path;

  const handleOpenMap = () => {
    setMapModalOpen(true);
  };

  const handleCloseMap = () => {
    setMapModalOpen(false);
  };

  //Location Data
  const gpsData =
    typeof DetailList?.gps === 'string'
      ? JSON.parse(DetailList?.gps)
      : DetailList?.gps;
  const lat = parseFloat((gpsData || {}).lat);
  const lng = parseFloat((gpsData || {}).long);

  //Business Calendar
  const businessCalendar =
    typeof DetailList?.calendar === 'string'
      ? JSON.parse(DetailList?.calendar)
      : DetailList?.calendar;
  const now = new Date();
  const currentDay = now
    .toLocaleString('en-us', { weekday: 'long' })
    .toUpperCase(); // "MONDAY"

  const currentTime = now.getHours() * 60 + now.getMinutes();

  const timeToMinutes = (timeStr) => {
    const [time, period] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (period === 'PM' && hours < 12) hours += 12;
    if (period === 'AM' && hours === 12) hours -= 12;
    return hours * 60 + minutes;
  };

  let isOpen = false;
  let nextActionTime = ''; // Time for the next action

  const todaySchedule = (businessCalendar || {})[currentDay];

  if (todaySchedule) {
    const { status, openTime, endTime } = todaySchedule;

    if (status === 'مفتوح' || status === 'OPEN') {
      // "Open" status
      const openMinutes = timeToMinutes(openTime);
      const closeMinutes = timeToMinutes(endTime);

      if (currentTime >= openMinutes && currentTime <= closeMinutes) {
        isOpen = true;
        nextActionTime = endTime; // Display closing time
      } else if (currentTime < openMinutes) {
        isOpen = false;
        nextActionTime = openTime; // Display opening time
      } else {
        isOpen = false;
        nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display next day's opening time if closed
      }
    } else {
      isOpen = false;
      nextActionTime = (businessCalendar || {})[currentDay]?.openTime; // Display opening time if closed
    }
  }

  //Social Media Data
  const socialMediaData =
    typeof DetailList?.socialMedia === 'string'
      ? JSON.parse(DetailList?.socialMedia)
      : DetailList?.socialMedia;
  return (
    <div>
      <div className="user-banner">
        <CommonBanner bannerImages={bannerImages} />

        <div className="user-logo-holder">
          <div className="container">
            <div className="user-logo-holder-wrap">
              <div className="row align-items-center justify-content-between">
                <div className="col-12 col-sm-12 col-md-6 mb-3 mb-sm-3 mb-md-0">
                  <div className="row align-items-center">
                    <div className="col-4 col-sm-4 col-md-3">
                      <img
                        src={
                          logo || 'assets/images/user/driving-schools/kmc.jpg'
                        }
                        alt=""
                        className="img-fluid user-garage-logo"
                        style={{
                          objectFit: 'contain',
                          backgroundColor: '#fff',
                        }}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = 'assets/images/user/taxi/user.jpg';
                        }}
                      />
                    </div>
                    <div className="col-8 col-sm-8 col-md-auto">
                      <h5 className="mb-3">
                        {DetailList?.airConditioningName}
                      </h5>
                      <ul className="list-inline mb-0 wpm">
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Calendar"
                        >
                          <a
                            target="_blank"
                            href="javascript:void(0);"
                            data-toggle="modal"
                            data-target="#calendar-modal"
                          >
                            <i class="far fa-calendar-alt"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Whatsapp"
                        >
                          <a
                            target="_blank"
                            onClick={() => recordListingEvent(airConditioningId, 'airConditioning', 'CONTACT')} href={`https://wa.me/${`${DetailList?.whatsAppNumberCountryCode}${DetailList?.whatsAppNumber}`.replace(/\D/g, '')}`}
                          >
                            <i class="fab fa-whatsapp"></i>
                          </a>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Call"
                        >
                          <CallLink
                            target="_blank"
                            onClick={() => recordListingEvent(airConditioningId, 'airConditioning', 'CONTACT')} record={DetailList}
                          >
                            <i class="fas fa-phone"></i>
                          </CallLink>
                        </li>
                        <li
                          class="list-inline-item"
                          data-toggle="tooltip"
                          data-placement="top"
                          title="Location Map"
                        >
                          <a href="javascript:void(0);" onClick={handleOpenMap}>
                            <i class="fas fa-map-marker-alt"></i>
                          </a>
                          <MapModalForView
                            open={mapModalOpen}
                            handleClose={handleCloseMap}
                            currentLocation={{
                              lat: lat,
                              long: lng,
                            }}
                          />
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>

                <div className="col-12 col-sm-12 col-md-auto">
                  {(isOpen || (nextActionTime && `${nextActionTime}`.trim() !== '')) && (
                    <p class="mb-3">
                    <span class={isOpen ? 'open-time' : 'close-time'}>
                      {isOpen ? t('Open Now') : t('Close Now')}
                    </span>{' '}
                    |{' '}
                    <span class={isOpen ? 'close-time' : 'open-time'}>
                      {isOpen
                        ? `${t('Closes at')} ${nextActionTime}`
                        : `${t('Open at')} ${nextActionTime}`}
                    </span>
                  </p>
                  )}
                  <ul className="list-inline mb-0">
                    {DetailList?.website && (
                      <li className="list-inline-item">
                        <a
                          href={externalUrl(DetailList?.website)}
                          target="_blank"
                          rel="noreferrer"
                          title="Website"
                        >
                          <i
                            className="fas fa-globe"
                            style={{ fontSize: '24px', color: '#0e76a8', verticalAlign: 'middle' }}
                          ></i>
                        </a>
                      </li>
                    )}
                    {socialMediaData?.INSTAGRAM && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.INSTAGRAM)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/instagram.png"
                            alt="Instagram"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.FACEBOOK && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.FACEBOOK)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/facebook.png"
                            alt="Facebook"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.TWITTER && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.TWITTER)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/twitter.png"
                            alt="Twitter"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.LINKEDIN && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.LINKEDIN)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/linkedin.png"
                            alt="Linkedin"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.YOUTUBE && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.YOUTUBE)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/youtube.png"
                            alt="Youtube"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.SNAPCHAT && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.SNAPCHAT)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/snapchat.png"
                            alt="Snapchat"
                          />
                        </a>
                      </li>
                    )}
                    {socialMediaData?.GOOGLEPLUS && (
                      <li className="list-inline-item">
                        <a href={externalUrl(socialMediaData?.GOOGLEPLUS)} target="_blank" rel="noopener noreferrer">
                          <img
                            src="assets/images/service-provider/google-plus.png"
                            alt="Google Plus"
                          />
                        </a>
                      </li>
                    )}
                  </ul>
                </div>
              </div>

              {/* <!-- CALENDAR  MODAL --> */}
              <div
                class="modal fade"
                id="calendar-modal"
                tabindex="-1"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
                  <div class="modal-content">
                    <div class="modal-header">
                      <h5 class="modal-title">{t('Timing')}</h5>
                      <button
                        type="button"
                        class="close"
                        data-dismiss="modal"
                        aria-label="Close"
                      >
                        <span aria-hidden="true">&times;</span>
                      </button>
                    </div>
                    <div class="modal-body">
                      <table class="table table-bordered table-striped">
                        <tbody>
                          <tr>
                            <td scope="col">{t('Day')}</td>
                            <td scope="col">{t('Open')}</td>
                            <td scope="col">{t('Close')}</td>
                          </tr>
                          {[
                            'SUNDAY',
                            'MONDAY',
                            'TUESDAY',
                            'WEDNESDAY',
                            'THURSDAY',
                            'FRIDAY',
                            'SATURDAY',
                          ].map((day) => {
                            const status = openStatus.includes(
                              businessCalendar?.[day]?.status
                            );

                            return status ? (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.openTime}
                                </td>
                                <td scope="col">
                                  {businessCalendar?.[day]?.endTime}
                                </td>
                              </tr>
                            ) : (
                              <tr>
                                <td scope="col">{t(day)}</td>
                                <td scope="col">{t('Closed')}</td>
                                <td scope="col">{t('Closed')}</td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-secondary"
                        data-dismiss="modal"
                      >
                        {t('Close')}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="main-content-area">
        <div className="container">
          <div className="row">
            <h5 className="cav-section-title">{t('About Us')}</h5>
            {DetailList?.about?.split('\n').map((line, index) => (
              <p key={index}>{line}</p>
            ))}
            <p>{DetailList?.category}</p>
            {/* Address intentionally omitted here; it should not appear in the description/About Us. */}
            {/* [CF-5] Website moved to an icon beside the social icons. */}
          </div>
          <div className="row">
            <h5 className="cav-section-title">{t('Services Provided')}</h5>
            {/* [CF 2026-08-09 #13] Client: A/C should list its services the way
                Garages and Quick Services do — the service name plus the car
                brands it supports — instead of the plain name-only scroller.
                Same `cav-part-card` / `cav-brand-chip` classes as those pages
                and the spare-parts shop card, so all four read as one design.
                NOTE the names come from the shared `services` master, which
                still holds only placeholder rows; the layout is right, the
                vocabulary is content the client owns. */}
            <div
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: '12px',
                marginTop: '4px',
                width: '100%',
                /* `.cav-part-card` is `height:100%`. This wrapper is a direct
                   child of a Bootstrap `.row` (a flex container), so it was
                   being stretched to the row's height and the cards grew with
                   it — a service with three chips rendered as a half-screen
                   box. Opt out of both stretches. */
                alignSelf: 'flex-start',
                alignItems: 'flex-start',
              }}
            >
              {(DetailList?.services || []).map((s, si) => {
                /* [CF 2026-08-18] The service master had only an English
                   column, so the card title stayed English on the Arabic
                   site. `serviceAr` now exists on the master and comes back
                   with the listing; fall back to whichever side is filled so
                   a service with no Arabic yet still shows its name. */
                const name = isRTL
                  ? s?.serviceAr || s?.service
                  : s?.service || s?.serviceAr;
                const brandNames = (s?.brands || [])
                  .map((b) => {
                    const brand = b?.brand || b;
                    return isRTL
                      ? brand?.nameAr || brand?.name
                      : brand?.name || brand?.nameAr;
                  })
                  .filter(Boolean);
                return (
                  <div
                    key={si}
                    className="cav-part-card"
                    style={{
                      flex: '1 1 240px',
                      minWidth: '200px',
                      maxWidth: '360px',
                      textAlign: isRTL ? 'right' : 'left',
                    }}
                  >
                    <div
                      className="cav-part-name"
                      /* no brands → drop the rule, else it dangles */
                      style={
                        brandNames.length
                          ? undefined
                          : {
                              borderBottom: 'none',
                              marginBottom: 0,
                              paddingBottom: 0,
                            }
                      }
                    >
                      {name}
                    </div>
                    {brandNames.length > 0 && (
                      <div className="cav-part-brands">
                        {brandNames.map((bn, bi) => (
                          <span key={bi} className="cav-brand-chip">
                            {bn}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
